var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "v-input",
      class: [
        {
          "v-input--prefix": _vm.icon,
          "v-input-textarea": _vm.type === "textarea",
        },
        _vm.sizeCss,
      ],
      style: { width: _vm.inputWidth },
    },
    [
      _vm.icon
        ? _c("span", {
            staticClass: "v-input__middle v-input__icon v-input__icon--prefix",
            class: _vm.icon,
          })
        : _vm._e(),
      _vm.type !== "textarea"
        ? [
            _c("input", {
              ref: "input",
              staticClass: "input-text",
              class: {
                "is-disabled": _vm.isDisabled !== false,
                "is-hover": _vm.isHover,
                "is-focus": _vm.isFocus,
              },
              style: { paddingRight: _vm.subffixWidth + "px" },
              attrs: {
                type: _vm.showPassword
                  ? _vm.passwordVisible
                    ? "text"
                    : "password"
                  : _vm.type,
                name: _vm.name,
                "data-name": _vm._name,
                disabled: _vm.isDisabled !== false,
                readonly: _vm.readonly,
                minlength: _vm.minlength,
                maxlength: _vm.maxlength,
                placeholder: _vm.placeholder,
              },
              on: {
                focus: _vm.setFocus,
                blur: _vm.blur,
                change: _vm.changeValue,
                keydown: function ($event) {
                  return _vm.$emit("keydown", $event)
                },
                input: _vm.handlerInput,
              },
            }),
          ]
        : [
            _c("textarea", {
              ref: "input",
              staticClass: "input-textarea",
              class: { "is-disabled": _vm.isDisabled !== false },
              attrs: {
                rows: _vm.rows,
                name: _vm.name,
                "data-name": _vm._name,
                disabled: _vm.isDisabled !== false,
                readonly: _vm.readonly,
                minlength: _vm.minlength,
                maxlength: _vm.maxlength,
                placeholder: _vm.placeholder,
              },
              on: {
                focus: _vm.setFocus,
                blur: _vm.blur,
                change: _vm.changeValue,
                input: _vm.handlerInput,
              },
            }),
          ],
      !_vm.supportPlaceholder && !_vm.inputValue
        ? _c(
            "div",
            {
              staticClass: "placeholder-text",
              on: {
                click: function ($event) {
                  return _vm.focus()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.placeholder) + " ")]
          )
        : _vm._e(),
      _vm.hasSuffix
        ? _c("span", { ref: "suffix", staticClass: "v-input__icon--suffix" }, [
            _vm.isSearch
              ? _c("span", {
                  staticClass:
                    "v-input__search v-input__icon pointer v-icon-search",
                  on: {
                    mouseover: function ($event) {
                      _vm.isHover = true
                    },
                    mouseout: function ($event) {
                      _vm.isHover = false
                    },
                    click: function ($event) {
                      return _vm.handlerSearch()
                    },
                  },
                })
              : _vm._e(),
            _vm.inputValue && _vm.isClear !== false
              ? _c("span", {
                  staticClass:
                    "v-input__middle v-input__icon pointer v-icon-close-plane",
                  on: {
                    click: function ($event) {
                      return _vm.clearValue()
                    },
                  },
                })
              : _vm._e(),
            _vm.showPassword
              ? _c("span", {
                  staticClass: "v-input__middle v-input__icon pointer",
                  class: _vm.passwordVisible
                    ? "v-icon-eye-on"
                    : "v-icon-eye-off",
                  on: { click: _vm.handlerPasswordVisible },
                })
              : _vm._e(),
            _vm.suffixIcon
              ? _c("span", {
                  staticClass: "v-input__middle v-input__icon",
                  class: _vm.suffixIcon,
                })
              : _vm._e(),
            _vm.showWordLimit && this.maxlength
              ? _c(
                  "span",
                  { staticClass: "v-input__middle input-word-limit" },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.valueLen + "/" + this.maxlength) + " "
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._t("suffix"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }